export const INITIAL_LANGUAGE: string = 'pl';

export const AVAILABLE_LANGUAGES = [
  { name:'Polski', value:'pl', code:'PL' },
  { name:'Angielski', value:'en', code:'EN' },
  { name:'Ukraiński', value:'uk', code:'UA' },
];